import { render, staticRenderFns } from "./DeleteClientFromZone.vue?vue&type=template&id=b701a6c4&scoped=true&"
import script from "./DeleteClientFromZone.vue?vue&type=script&lang=js&"
export * from "./DeleteClientFromZone.vue?vue&type=script&lang=js&"
import style0 from "./DeleteClientFromZone.vue?vue&type=style&index=0&id=b701a6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b701a6c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VProgressCircular,VRow,VSelect,VTextField})
